const $$splitComponentImporter = () => import('/app/apps/web/src/routes/_authenticated-user/superuser/afpant/$orgNumber/pantedokumentsvar/$pantedokumentResponseId/index.tsx?tsr-split=component');
import { lazyRouteComponent } from '@tanstack/react-router';
import { routeLoaderApiClient } from "@/lib/api";
import { createFileRoute } from "@tanstack/react-router";
export const Route = createFileRoute("/_authenticated-user/superuser/afpant/$orgNumber/pantedokumentsvar/$pantedokumentResponseId/")({
  loader: async ({
    params
  }) => {
    const {
      orgNumber,
      pantedokumentResponseId
    } = params;
    const res = await routeLoaderApiClient.superuser.afpant[":orgNumber"]["pantedokument-response"][":pantedokumentResponseId"].$get({
      param: {
        orgNumber,
        pantedokumentResponseId
      }
    });
    if (res.ok === false) {
      throw new Error("Failed to fetch pantedokument response");
    }
    return {
      response: await res.json()
    };
  },
  head: () => ({
    meta: [{
      title: "Pantedokumentsvar | Alice & Bob"
    }]
  }),
  component: lazyRouteComponent($$splitComponentImporter, 'component', () => Route.ssr)
});